export enum NavLinks {
  FIND_CARE = 'FIND_CARE',
  PRICE_CARE = 'PRICE_CARE',
}
export enum ErrorMessages {
  ERROR_404 = 'ERROR_404',
  UH_OH = 'UH_OH',
  ERROR_PAGE_TEXT = 'ERROR_PAGE_TEXT',
  ERROR_PAGE_SUBTEXT = 'ERROR_PAGE_SUBTEXT',
  REFRESH = 'REFRESH',
}
